export interface IGetProfilePictureOutput {
	avatarUrl: string | undefined;
}
export class GetProfilePictureOutput implements IGetProfilePictureOutput {

	constructor(data?: IGetProfilePictureOutput) {
		if (data) {
			for (const property in data) {
				if (data.hasOwnProperty(property)) {
					(<any>this)[property] = (<any>data)[property];
				}
			}
		}
	}
	avatarUrl!: string | undefined;

	static fromJS(data: any): GetProfilePictureOutput {
		data = typeof data === 'object' ? data : {};
		const result = new GetProfilePictureOutput();
		result.init(data);
		return result;
	}

	init(data?: any) {
		if (data) {
			this.avatarUrl = data.result['avatarUrl'];
		}
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data['profilePicture'] = this.avatarUrl;
		return data;
	}
}


